'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setSearchExclusion = exports.getUserExcludedFacets = exports.annotateFacetExclusions = exports.SET_FACET_EXCLUSION_SUCCESS = exports.SET_FACET_EXCLUSION_REQUEST = exports.SET_FACET_EXCLUSION_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _completeAccount = require('./completeAccount');

var _user = require('./user');

var _login = require('./login');

var _passwordReset = require('./passwordReset');

var _updateAccount = require('./updateAccount');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _confirmPassword = require('./confirmPassword');

var _createAccount = require('./createAccount');

var _reselect = require('reselect');

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SET_FACET_EXCLUSION_FAIL = exports.SET_FACET_EXCLUSION_FAIL = 'la/domain/bidderData/SET_FACET_EXCLUSION_FAIL';
var SET_FACET_EXCLUSION_REQUEST = exports.SET_FACET_EXCLUSION_REQUEST = 'la/domain/bidderData/SET_FACET_EXCLUSION_REQUEST';
var SET_FACET_EXCLUSION_SUCCESS = exports.SET_FACET_EXCLUSION_SUCCESS = 'la/domain/bidderData/SET_FACET_EXCLUSION_SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    excludedFacets: {
        auctionHouse: []
    },
    loaded: 0,
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var time = void 0;

    switch (action.type) {
        case _completeAccount.COMPLETE_ACCOUNT_SUCCESS:
        case _confirmPassword.CONFIRM_PASSWORD_SUCCESS:
        case _user.LOAD_BIDDER_DATA_SUCCESS:
        case _login.LOGIN_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
        case _updateAccount.UPDATE_ACCOUNT_SUCCESS:
            time = action.meta.actionTime;
            return (0, _extends4.default)({}, state, {
                excludedFacets: renameSearchExclusionsToFacetIds(action.payload.searchExclusions),
                loaded: time,
                loading: false
            });
        case _completeAccount.COMPLETE_ACCOUNT_REQUEST:
        case _createAccount.CREATE_ACCOUNT_REQUEST:
        case _user.LOAD_BIDDER_DATA_REQUEST:
        case _login.LOGIN_REQUEST:
        case _passwordReset.PASSWORD_RESET_REQUEST:
        case SET_FACET_EXCLUSION_REQUEST:
        case _updateAccount.UPDATE_ACCOUNT_REQUEST:
            return (0, _extends4.default)({}, state, {
                loading: true
            });
        case _user.LOG_OUT_BIDDER:
            return DEFAULT_STATE;
        case SET_FACET_EXCLUSION_FAIL:
            return (0, _extends4.default)({}, state, {
                loading: false
            });
        case SET_FACET_EXCLUSION_SUCCESS:
            time = action.meta.actionTime;
            return (0, _extends4.default)({}, state, {
                excludedFacets: renameSearchExclusionsToFacetIds(action.payload),
                loaded: time,
                loading: false
            });
        default:
            return state;
    }
}

// TODO: remove this, and instead update the item api to return correct names

/* HELPERS */
var FACET_ID_LEGEND = {
    houseIds: 'auctionHouse'
};

// Maps facet names returned by the api to facet names used within the application
var renameSearchExclusionsToFacetIds = function renameSearchExclusionsToFacetIds() {
    var searchExclusions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _keys2.default)(searchExclusions).reduce(function (excludedFacets, key) {
        return (0, _extends4.default)({}, excludedFacets, (0, _defineProperty3.default)({}, FACET_ID_LEGEND[key], searchExclusions[key].map(function (option) {
            return option.toString();
        })));
    }, {});
};

// END TODO

var annotateFacetExclusions = exports.annotateFacetExclusions = function annotateFacetExclusions() {
    var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var exclusions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return facets.map(function (facet) {
        return !exclusions[facet.id] ? facet : (0, _extends4.default)({}, facet, {
            excludable: true,
            options: facet.options.map(function (option) {
                return (0, _extends4.default)({}, option, {
                    excluded: exclusions[facet.id].includes(option.id)
                });
            })
        });
    });
};

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.searchExclusions;
};

var getUserExcludedFacets = exports.getUserExcludedFacets = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.excludedFacets || (0, _cloneDeep2.default)(DEFAULT_STATE.excludedFacets);
});

/* ACTION CREATORS */
var setSearchExclusion = exports.setSearchExclusion = function setSearchExclusion(facetId, optionId, exclude) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, requestParams, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);
                            requestParams = { authToken: authToken, deployment: deployment, exclude: exclude, facetId: facetId, optionId: optionId };
                            _context.prev = 4;

                            dispatch({
                                type: SET_FACET_EXCLUSION_REQUEST
                            });
                            _context.next = 8;
                            return _api.Bidder.postSetSearchFacetOptionExclusion(requestParams);

                        case 8:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: SET_FACET_EXCLUSION_SUCCESS
                            });
                            _context.next = 15;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](4);

                            dispatch({
                                error: true,
                                payload: _context.t0.error_message,
                                type: SET_FACET_EXCLUSION_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[4, 12]]);
        }));

        return function (_x6, _x7) {
            return _ref.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/searchExclusions.js
// module id = 7Lxj
// module chunks = 60